import { App } from '../App';
import { useAuth } from './AuthContext';
import { AccessBlocked, BootSplash, LoginScreen } from './LoginScreen';

/**
 * The door.
 *
 * Nothing in the editor mounts until the server has confirmed the cookie and
 * the account is allowed to work. A session that exists but is expired or
 * suspended gets a screen of its own, not a half-loaded workspace.
 */
export function Root(): JSX.Element {
  const { user, access, loading } = useAuth();

  if (loading) return <BootSplash />;
  if (!user) return <LoginScreen />;
  if (access && !access.ok) return <AccessBlocked />;

  return <App />;
}
